class MFRProductImages {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      image: ".product-top__image",
      thumbnails: ".product-top__images-thumbnails",
      thumbnail: ".product-top__images-thumbnail",
    };

    this.flickityOptions = {
      selectedAttraction: 0.1,
      friction: 0.55,
      prevNextButtons: false,
      contain: true,
      cellAlign: "center",
      pageDots: false,
      wrapAround: true,
      groupCells: false,
      draggable: true,
    };

    this.init();
  }

  init() {
    this.$image = this.$element.find(this.selectors.image);

    this.initThumbnails();
    this.initCarousel();

    this.$image.on("click", this.__handleImageClick.bind(this));
  }

  __handleImageClick(e) {
    if (this.isDragging || $(".product-top__image-modal").length ) return;
    const image = $( e.currentTarget ).find( "img" ).clone();
    const element = this.generateImageModal(image).hide();

    $( "body" ).append( element );
    element.fadeIn();

    setTimeout(() => element.find(".with-message").removeClass( "with-message" ), 2000 );

    element.find( ".product-top__image-modal-close" ).on( "click", () => element.fadeOut( () => element.remove() ) );
  }

  generateImageModal(image) {
    const element = $(`
      <div class="product-top__image-modal">
        <button class="product-top__image-modal-close">
          ×
        </button>
        <div class="product-top__image-modal-inner with-message">
        </div>
      </div>
      <div class="product-top__image-modal-overlay"></div>
    `);
    element.find(".product-top__image-modal-inner").append( image );
    element.find(".product-top__image-modal-inner").zoom({
      url: element.find(".product-top__image-modal-inner img").attr( "src" )
    });
    return element;
  }

  initCarousel() {
    this.$element.flickity({
      ...this.flickityOptions,
      on: {
        select: (index) => {
          this.$element
            .siblings(this.selectors.thumbnails)
            .find(this.selectors.thumbnail)
            .removeClass("is-active");
          this.$element
            .siblings(this.selectors.thumbnails)
            .find(`${this.selectors.thumbnail}[data-index="${index}"]`)
            .addClass("is-active");
        },
        dragStart: () => {
          this.isDragging = true;
        },
        dragEnd: () =>
          setTimeout(() => {
            this.isDragging = false;
          }, 100),
      },
    });
  }

  initThumbnails() {
    this.$element.after(this.generateThumbnails());
    const thumbnail = this.$element
      .siblings(this.selectors.thumbnails)
      .find(this.selectors.thumbnail);

    thumbnail.on("click", this.__handleThumbnailClick.bind(this));
  }

  __handleThumbnailClick(e) {
    this.$element.flickity("selectCell", $(e.currentTarget).data("index"));
  }

  generateThumbnails() {
    const thumbnails = $(
      `<div class="${this.selectors.thumbnails.replace(".", "")}"></div>`
    );

    this.$image.each((i, e) => {
      let isActive = "";
      if (i == 0) isActive = "is-active";
      const thumbnail = $(`
                <div class="${this.selectors.thumbnail.replace(
                  ".",
                  ""
                )} ${isActive}" data-index="${i}">
                </div>
            `);

      thumbnail.append($(e).find("img").clone().get(0));
      thumbnails.append(thumbnail);
    });
    return thumbnails;
  }
}